import axios from "axios";

const config = {
  headers: {
    "X-Requested-With": "XMLHttpRequest",
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
};

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_ENDPOINT}/api`,
  ...config,
});

export const baseApi = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  ...config,
});

api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (
      axios.isAxiosError(error) &&
      (error?.response?.status === 401 || error?.response?.status === 419)
    ) {
      window.location.reload();
    }
    return Promise.reject(error);
  }
);
